import type { Opportunity } from '../types';

export function formatApplicantCount(value?: number): string | null {
  if (value == null) return null;
  if (value >= 10000000) return `${(value / 10000000).toFixed(1)} Cr`;
  if (value >= 100000) return `${Math.round(value / 100000)} Lakh`;
  return value.toLocaleString('en-IN');
}

export function renderCompetitionStars(level = 3): string {
  const filled = Math.max(1, Math.min(5, level));
  return `${'★'.repeat(filled)}${'☆'.repeat(5 - filled)}`;
}

export function normalizeDocumentLabel(doc: string): string {
  const map: Record<string, string> = {
    Photo: 'Photograph',
    'ID proof': 'Aadhaar',
    'Graduation certificate': 'Graduation Certificate',
    'Category certificate (if applicable)': 'Category Certificate',
    'Category certificate': 'Category Certificate',
    'PG marksheet': 'PG Marksheet',
  };
  return map[doc] ?? doc;
}

export function getDocumentChecklistKey(opportunityId: string): string {
  return `wfx-opp-docs-${opportunityId}`;
}

export function loadCheckedDocuments(opportunityId: string): Set<string> {
  try {
    const raw = localStorage.getItem(getDocumentChecklistKey(opportunityId));
    if (!raw) return new Set();
    return new Set(JSON.parse(raw) as string[]);
  } catch {
    return new Set();
  }
}

export function saveCheckedDocuments(opportunityId: string, docs: Set<string>) {
  try {
    localStorage.setItem(getDocumentChecklistKey(opportunityId), JSON.stringify(Array.from(docs)));
  } catch {
    /* ignore */
  }
}

export function hasSalaryCard(opp: Opportunity): boolean {
  return Boolean(opp.salary || opp.salaryLevel || opp.salaryType);
}

export function hasVacancyAnalytics(opp: Opportunity): boolean {
  return opp.vacancies != null || opp.postsCount != null || opp.departmentsCount != null;
}
